import React from 'react';
import moment from 'moment';
import { Box, Card } from '@mui/material';
import { Control } from 'react-hook-form/dist/types/form';
import { AutocompleteField, DateRangeWithPeriods } from 'components/form';
import { LenderPerformanceFilterFormValues } from '../../../types';
import { useLenderPerformanceFilterOptions } from '../../../hooks/useLenderPerformanceFilterOptions';

interface Props {
  control: Control<LenderPerformanceFilterFormValues>;
  onRangeChange: (range: { endDate: moment.Moment; startDate: moment.Moment }) => Promise<void>;
}

export const LenderPerformanceFilters = ({ control, onRangeChange }: Props) => {
  const { lenderOptions, salesRepOptions, locationOptions, isLocationsLoading } = useLenderPerformanceFilterOptions();

  return (
    <Card sx={{ p: 2 }}>
      <Box
        sx={{
          display: 'grid',
          gap: '1rem',
          alignItems: 'flex-start',
          gridTemplateColumns: { xs: '1fr', md: '2fr 1fr 1fr 1fr' },
        }}
      >
        <DateRangeWithPeriods control={control} nameTo="to" nameFrom="from" onRangeChange={onRangeChange} />

        <AutocompleteField
          multiple
          name="lenders"
          control={control}
          options={lenderOptions}
          textFieldProps={{ label: 'Displayed Lenders', variant: 'standard' }}
        />

        <AutocompleteField
          multiple
          name="salesReps"
          control={control}
          options={salesRepOptions}
          textFieldProps={{ label: 'Displayed Sales reps', variant: 'standard' }}
        />

        <AutocompleteField
          multiple
          name="locations"
          control={control}
          options={locationOptions}
          isLoading={isLocationsLoading}
          textFieldProps={{ label: 'Displayed Locations', variant: 'standard' }}
        />
      </Box>
    </Card>
  );
};
